export const scenarios = {
  en: [
    {
      id: 'even',
      title: ['Description of scenario 1', '(Even distribution planting)'],
      name: 'Even distribution planting',
      description:
        'Scenario 1 represents an even distribution planting of selected crops to use as much land area as possible until the water runs out.',
    },
    {
      id: 'planting',
      title: [
        'Description of scenario 2',
        '(Custom fixed percentage planting)',
      ],
      name: 'Custom fixed percentage planting',
      description:
        "Scenario 2 represents a custom fixed percentage planting based on the user's decision about crop(s) planting percentage adding up to 100% and to use as much land area as possible until water runs out.",
    },
    {
      id: 'optimal',
      title: ['Description of scenario 3', '(Maximum profit)'],
      name: 'Maximum profit',
      description:
        'Scenario 3 represents planting area for the selected crop(s) that maximizes profits with an allocated water supply.',
    },
    {
      id: 'equal',
      title: ['Description of scenario 4', '(Constrained uniform planting)'],
      name: 'Constrained uniform planting',
      description:
        'Scenario 4 represents equal area optimization. For example, if the farmer has 1 hectare of land and wants to plant 4 crops, the equal area optimization will prevent any one crop from using more than 1/4 hectare of land. Due to water availability, all crops may not necessarily be optimized to the exact same area.',
    },
    {
      id: 'custom',
      title: [
        'Description of scenario 5',
        '(Custom area planting optimization)',
      ],
      name: 'Custom area planting optimization',
      description:
        'Planting multiple crops provides more security in case one crop fails. Scenario 5 allows the user to input the maximum percent of area they would be willing to dedicate to a single crop. Each value can be up to 100%, but the lower each value, the higher the planting diversity will be. If all values are set to 100%, the result will be the same as Scenario 3.',
    },
  ],
  es: [
    {
      id: 'even',
      title: [
        'Descripción del escenario 1',
        '(Siembro de distribución uniforme)',
      ],
      name: 'Siembro de distribución uniforme',
      description:
        'El escenario 1 representa un siembro de distribución uniforme de cultivos seleccionados para utilizar la mayor cantidad de superficie de tierra posible hasta que se agote el agua.',
    },
    {
      id: 'planting',
      title: [
        'Descripción del escenario 2',
        '(Porcentaje fijo personalizado de siembra)',
      ],
      name: 'Porcentaje fijo personalizado de siembra',
      description:
        'El escenario 2 representa un porcentaje de plantación fijo personalizado basado en la decisión del usuario sobre el porcentaje de plantación de cultivos que suman hasta el 100% y para usar tanta superficie de tierra como sea posible hasta que se agote el agua.',
    },
    {
      id: 'optimal',
      title: ['Descripción del escenario 3', '(Ganancias máximas)'],
      name: 'Ganancias máximas',
      description:
        'El escenario 3 representa el área de plantación para los cultivos seleccionados que maximiza los beneficios con un suministro de agua asignado.',
    },
    {
      id: 'equal',
      title: ['Descripción del escenario 4', '(Siembra uniforme restingida)'],
      name: 'Siembra uniforme restingida',
      description:
        'El escenario 4 representa la optimización de área igual. Por ejemplo, si el agricultor tiene 1 hectárea de tierra y quiere plantar 4 cultivos, la optimización de área igual evitará que cualquier cultivo utilice más de 1/4 hectárea de tierra. Debido a la disponibilidad de agua, es posible que no todos los cultivos se optimicen necesariamente para la misma área exacta.',
    },
    {
      id: 'custom',
      title: [
        'Descripción del escenario 5',
        '(Optimización de plantación de área personalizada)',
      ],
      name: 'Optimización de plantación de área personalizada',
      description:
        'Plantar múltiples cultivos proporciona más seguridad en caso de que un cultivo falle. El escenario 5 permite al usuario introducir el porcentaje máximo de área que estaría dispuesto a dedicar a un solo cultivo. Cada valor puede ser de hasta el 100%, pero cuanto menor sea cada valor, mayor será la diversidad de siembra. Si todos los valores se establecen en 100%, el resultado será el mismo que el del escenario 3.',
    },
  ],
  qu: [
    {
      id: 'even',
      title: 'TRANSLATE',
      name: 'TRANSLATE',
      description: 'TRANSLATE',
    },
    {
      id: 'planting',
      title: 'TRANSLATE',
      name: 'TRANSLATE',
      description: 'TRANSLATE',
    },
    {
      id: 'optimal',
      title: 'TRANSLATE',
      name: 'TRANSLATE',
      description: 'TRANSLATE',
    },
    {
      id: 'equal',
      title: 'TRANSLATE',
      name: 'TRANSLATE',
      description: 'TRANSLATE',
    },
    {
      id: 'custom',
      title: 'TRANSLATE',
      name: 'TRANSLATE',
      description: 'TRANSLATE',
    },
  ],
};
